export default __webpack_public_path__ + "static/media/sass.3fc39440.png";